import { render } from "./Edit.vue?vue&type=template&id=cf3ffdbc"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/services/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf3ffdbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf3ffdbc', __exports__)) {
    console.log('reload')
    api.reload('cf3ffdbc', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=cf3ffdbc", () => {
    console.log('re-render')
    api.rerender('cf3ffdbc', render)
  })

}


export default __exports__